import { TvHistoryConvertor } from '../Convertors/TvHistoryConvertor';
import throttle from 'lodash.throttle';
import { Periods } from '@shared/utils/History/TFInfo';
export class TvCashItemManager {
    constructor(cashItem, timeOffset, timeZone) {
        this.onBarUpdated = null;
        this.historyConvertor = new TvHistoryConvertor();
        this.throttledOnBarUpdated = throttle((tvBar) => {
            if (this.onBarUpdated) {
                this.onBarUpdated(tvBar);
            }
        }, TvCashItemManager.THROTTLE_DELAY, { leading: true, trailing: true });
        this.cashItem = cashItem;
        this.timeOffset = timeOffset;
        this.timeZone = timeZone;
        this.cashItem.HistoryExpanded.Subscribe(this.onHistoryExpanded, this);
        this.cashItem.QuoteProcessed.Subscribe(this.onQuoteProcessed, this);
        this.removeHistory();
    }
    dispose() {
        this.onBarUpdated = null;
        this.cashItem.HistoryExpanded.UnSubscribe(this.onHistoryExpanded, this);
        this.cashItem.QuoteProcessed.UnSubscribe(this.onQuoteProcessed, this);
        this.cashItem.Dispose();
    }
    onHistoryExpanded(cashItem, oldLength, newLength) {
        this.throttledOnBarUpdated.flush();
        this.removeHistory();
    }
    onQuoteProcessed(cashItem, quote) {
        const barIndex = this.cashItem.FNonEmptyCashArray.length - 1;
        if (barIndex < 0)
            return;
        const baseInterval = this.cashItem.FNonEmptyCashArray[barIndex];
        const period = this.cashItem.FPeriod;
        const tvBar = this.historyConvertor.convertToTvBar(baseInterval, period, this.timeOffset, this.timeZone);
        this.callOnBarUpdated(tvBar, period);
    }
    setCallBacks(onBarUpdated, onResetCacheNeededCallback) {
        this.onBarUpdated = onBarUpdated;
        this.onResetCacheNeededCallback = onResetCacheNeededCallback;
    }
    callOnResetCacheNeededCallback() {
        if (this.onResetCacheNeededCallback) {
            this.onResetCacheNeededCallback();
        }
    }
    callOnBarUpdated(tvBar, period) {
        if (period === Periods.TIC && !isNullOrUndefined(this.onBarUpdated)) {
            this.onBarUpdated(tvBar);
        }
        else {
            this.throttledOnBarUpdated(tvBar);
        }
    }
    removeHistory() {
        const count = this.cashItem.FNonEmptyCashArray.length;
        if (count <= 1)
            return;
        this.cashItem.FNonEmptyCashArray = [this.cashItem.FNonEmptyCashArray[count - 1]];
        this.cashItem.FNonEmptyCashArray.length = 1;
        this.cashItem.FNonEmptyCashArrayCount = 1;
    }
}
// удаляем старые бары при создании
// удаляем старые бары когда срабатывает NextBar
// возвращаем ohlc bar для tv
TvCashItemManager.THROTTLE_DELAY = 200;
